var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c(_vm.layout,{tag:"component"},[_c('router-view',{scopedSlots:_vm._u([{key:"default",fn:function({ Component, route }){return [_c('transition',{attrs:{"name":"fade"}},[_c(Component,{key:route.path,tag:"component"})],1)]}}])})],1),_c('SupportChat')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }